import React, { useEffect, useState, useCallback } from "react";
import ListReportsUnimed from "./list.jsx";
import {
  Spinner,
  Pagination,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Table,
  Button,
  PaginationItem,
  PaginationLink,
  Alert,
  Label,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { validateDates } from "../../utils/validations";
import { Suport, ButtonOrder } from "./styles";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { deleteCookies } from "../../utils/functions";
import { useHistory, useLocation } from "react-router-dom";
import {
  faMicroscope,
  faSort,
  faBroom,
  faSearch,
  faCalendarWeek,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ReportsUnimedView() {
  useEffect(() => {
    document.title = "CEDAP | Painel - Unimed";
  }, []);
  const [showWithoutOutcome, setShowWithoutOutcome] = useState(true);
  const [groupedReports, setGroupedReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const qtdPerPage = 5; // meses por página
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("desc");
  const [reports, setReports] = useState([]);
  const today = new Date();
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [isFilteredByDate, setIsFilteredByDate] = useState(false);
  const [isReportsNull, setReportsNull] = useState(false);
  let [search, setSearch] = useState("");
  const [fields, setFields] = useState({ dateStart: "", dateEnd: "" });

  const filteredReports = reports.filter((report) => {
    const isWithoutOutcome =
      report.CodDesfecho === null && report.DtaDesfecho === null;

    // Filtro de desfecho
    const matchesOutcome = showWithoutOutcome
      ? isWithoutOutcome
      : !isWithoutOutcome;

    // Filtro de nome
    const matchesSearch = report.NomPaciente?.toString()
      .toLowerCase()
      .includes(search.trim().toLowerCase());

    return matchesOutcome && matchesSearch;
  });

  const orderedReports = [...filteredReports].sort((a, b) => {
    const dateA = new Date(a.DtaSolicitacao);
    const dateB = new Date(b.DtaSolicitacao);
    return order === "desc" ? dateB - dateA : dateA - dateB;
  });

  const groupedByPatient = Object.values(
    orderedReports.reduce((acc, report) => {
      if (!acc[report.MatConvenio]) {
        acc[report.MatConvenio] = [];
      }
      acc[report.MatConvenio].push(report);
      return acc;
    }, {}),
  );

  const qtdPages = Math.ceil(groupedByPatient.length / qtdPerPage);
  // Pega somente os meses da página atual
  const paginatedReports = groupedByPatient.slice(
    qtdPerPage * (page - 1),
    qtdPerPage * page,
  );
  const history = useHistory();
  const location = useLocation();
  const token = cookie().get("tokenDoc");
  const username = cookie().get("username");
  const getReportsByDate = useCallback(async () => {
    const validationError = validateDates(fields.dateStart, fields.dateEnd);

    if (validationError) {
      alert(validationError);
      return;
    }
    setIsLoading(true);

    try {
      const response = await api()
        .user()
        .getAllUnimedMamaByDate(
          token,
          username,
          fields.dateStart,
          fields.dateEnd,
        );
      if (response.status === 401) {
        await deleteCookies();
        return history.replace({ pathname: "/login" });
      }

      if (response.status === 200) {
        setReportsNull(false);

        if (!response.output || response.output.length === 0) {
          setReportsNull(true);
          setReports([]);
          setIsLoading(false);
          return;
        }

        setReports(response.output);
        setPage(1);
        setIsFilteredByDate(true);
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [fields, history, token]);

  const getReports = useCallback(async () => {
    try {
      const response = await api().user().getAllUnimedMama(token);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
        return;
      }

      if (response.status === 200) {
        setIsFilteredByDate(false);
        setReports(response.output);
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [history, token]);

  useEffect(() => {
    if (username) {
      getReports();
    }

    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [username, location, history, getReports]);

  const refreshReports = () => {
    if (isFilteredByDate) {
      getReportsByDate();
    } else {
      getReports();
    }
  };
  const formatDateBR = (date) => {
    if (!date) return "";

    // se vier como string YYYY-MM-DD
    if (typeof date === "string") {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }

    // se já for Date (ex: today)
    return date.toLocaleDateString("pt-BR");
  };
  let startDate;
  let endDate;

  if (isFilteredByDate) {
    startDate = fields.dateStart;
    endDate = fields.dateEnd;
  } else {
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    startDate = firstDay;
    endDate = today;
  }

  const PaginationComponent = () => {
    let elements = [];

    for (let i = page - 3; i < page; i++) {
      if (i > 0) {
        elements.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let i = page - 1; i < qtdPages && i < page + 3; i++) {
      const thisPage = i + 1;
      elements.push(
        <PaginationItem key={thisPage} active={thisPage === page}>
          <PaginationLink onClick={() => setPage(thisPage)}>
            {thisPage}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return (
      <Pagination>
        <PaginationItem>
          <PaginationLink
            first
            onClick={() => setPage(1)}
            disabled={page === 1}
          />
        </PaginationItem>

        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {elements}

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink last onClick={() => setPage(qtdPages)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div>
      {!errorMessage && (
        <h1>
          <FontAwesomeIcon icon={faMicroscope} /> Relatório de Exames
        </h1>
      )}

      {isLoading ? (
        <div>
          <Spinner color="primary" /> Carregando...
        </div>
      ) : errorMessage ? (
        <Alert color="danger">
          Erro ao encontrar exames, atualize a página e tente novamente. Caso o
          problema persista, entre em contato com a equipe de suporte!
        </Alert>
      ) : (
        <>
          {groupedReports.length === 0}

          <>
            {paginatedReports.length === 0}

            <Modal centered size="lg" isOpen={modalOpen} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>
                Selecione o intervalo de datas
              </ModalHeader>

              <ModalBody>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Data Início</InputGroupText>
                        </InputGroupAddon>

                        <Input
                          type="date"
                          value={fields.dateStart}
                          onChange={(e) =>
                            setFields({ ...fields, dateStart: e.target.value })
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Data Fim</InputGroupText>
                        </InputGroupAddon>

                        <Input
                          type="date"
                          value={fields.dateEnd}
                          onChange={(e) =>
                            setFields({ ...fields, dateEnd: e.target.value })
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>

              <ModalFooter>
                <Button
                  color="primary"
                  onClick={() => {
                    toggleModal(); // fecha o modal
                    getReportsByDate(); // executa busca
                  }}
                >
                  <b>Buscar</b> <FontAwesomeIcon icon={faSearch} />
                </Button>
              </ModalFooter>
            </Modal>

            <ButtonOrder color="secondary" onClick={toggleModal}>
              Selecionar datas <FontAwesomeIcon icon={faCalendarWeek} />
            </ButtonOrder>
            <br />
            <span
              style={{ color: "#43494e", fontSize: "15px", marginTop: "10px" }}
            >
              Apresentando exames entre as datas{" "}
              <b>{formatDateBR(startDate)}</b> até{" "}
              <b>{formatDateBR(endDate)}</b>
            </span>

            <Row
              style={{
                marginTop: "5px",
                alignItems: "center",
              }}
            >
              <Col style={{ marginTop: 5 }} md={6}>
                <FormGroup style={{ height: "100%", marginBottom: 0 }}>
                  <InputGroup style={{ height: "100%" }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Buscar Paciente</InputGroupText>
                    </InputGroupAddon>

                    <Input
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                      required
                      type="text"
                    />
                  </InputGroup>
                </FormGroup>
              </Col>

              <Col
                md={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  color="light"
                  style={{ height: "38px" }}
                  onClick={() => setShowWithoutOutcome(!showWithoutOutcome)}
                >
                  <FontAwesomeIcon
                    icon={showWithoutOutcome ? faSort : faMicroscope}
                    style={{ marginRight: 6 }}
                  />
                  <b>
                    {showWithoutOutcome
                      ? "Exibindo exames sem desfecho"
                      : "Exibindo exames com desfecho"}
                  </b>
                </Button>
              </Col>
            </Row>

            {isReportsNull ? (
              <Alert color="warning">
                Nenhum exame encontrado nas datas selecionadas.
              </Alert>
            ) : (
              <Table striped bordered responsive style={{ marginTop: "10px" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}> </th>
                    <th style={{ textAlign: "center" }}>Cod Exame</th>
                    <th style={{ textAlign: "center" }}>Nome Paciente</th>
                    <th
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={() =>
                        setOrder(order === "desc" ? "asc" : "desc")
                      }
                    >
                      Dta. Solicitação{" "}
                      <FontAwesomeIcon
                        icon={order === "desc" ? faSort : faSort}
                        style={{
                          marginLeft: 3,
                          fontSize: "1.0rem",
                          opacity: 0.7,
                        }}
                      />
                    </th>
                    <th style={{ textAlign: "center" }}>Dta. Finalização</th>
                    <th style={{ textAlign: "center" }}>Diagnostico</th>
                    <th style={{ textAlign: "center" }}>Topografia</th>
                    <th style={{ textAlign: "center" }}>Nome exame</th>
                    <th style={{ textAlign: "center" }}>Matricula</th>
                    <th style={{ textAlign: "center" }}>Desfecho</th>
                    <th style={{ textAlign: "center" }}>Laudo</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedReports.map((patientReports, index) => (
                    <ListReportsUnimed
                      key={index}
                      reports={patientReports}
                      token={token}
                      username={username}
                      showWithoutOutcome={showWithoutOutcome}
                      refreshReports={refreshReports}
                    />
                  ))}
                </tbody>
              </Table>
            )}
            {qtdPages > 1 && <PaginationComponent />}
            <Suport href="https://wa.me/5547991865855" target="_blank">
              <u>Suporte</u>
              <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
            </Suport>
          </>
        </>
      )}
    </div>
  );
}
